import React from 'react';
import { motion } from 'framer-motion';
import { Check, Gift, Lock, Sparkles, Wallet, Zap } from 'lucide-react';
import { Button } from './Button';
import { CHECKOUT_URL, HERO_IMAGE, HERO_IMAGE_ALT, PRICE_LABEL, PRIMARY_CTA, packageIncludes } from '../data/offer';
import { trackCheckout } from '../utils/tracking';
export function PricingSection() {
  const firstBonusIndex = packageIncludes.findIndex(item => item.kind === 'bonus');
  const firstExtraIndex = packageIncludes.findIndex(item => item.kind === 'extra');
  return <section id="pricing" className="py-20 px-4 bg-[#F3F7FA] relative" data-id="element-217" data-mp="1s7sl0hgc5sx2">
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-218" data-mp="1x9rpxvrq4xw4">
        <div className="text-center mb-10" data-id="element-219" data-mp="227t5w7tush3d">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-3 text-[#0B2545] uppercase" data-id="element-220" data-mp="226i42djyxjew">
            Your Complete <span className="text-[#0A7D79]" data-id="element-221" data-mp="2wa1m6jhvx01">Nursing Instructor Atlas</span> Package
          </h2>
          <p className="text-slate-700/80 text-sm md:text-base" data-id="element-222" data-mp="7ubpr5vs2mid">
            Everything You Need to Plan, Explain, Demonstrate &amp; Assess Your Students More Effectively
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-[#D7E6EE] border-2 border-[#0B2545] rounded-3xl p-1 relative shadow-xl shadow-[#0B2545]/10" data-id="element-223" data-mp="1hodbjz7qd7nk">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#0A7D79] text-white font-bold px-5 py-1.5 rounded-full shadow uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap z-10" data-id="element-224" data-mp="20gfx9oz8be4o">
            <Sparkles size={14} data-id="element-225" data-mp="1rgas7lhicrto" /> Complete Package
          </div>
          <div className="bg-white rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-226" data-mp="1ri3yv0s4fc1o">
            <img src={HERO_IMAGE} alt={HERO_IMAGE_ALT} className="w-full max-w-md h-auto mx-auto mb-6" loading="lazy" data-id="element-227" data-mp="k3irqvwx0923" />

            <p className="text-sm font-bold tracking-widest text-[#025B57] mb-3" data-id="element-228" data-mp="hib1topqybp1">YOU RECEIVE</p>

            <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-[#F3F7FA] border border-slate-200 rounded-xl p-4" data-id="element-229" data-mp="mgcik2zp9yxc">
              <li className="text-xs font-bold tracking-widest text-[#025B57]" data-id="element-230" data-mp="7log6xpljgly">
                THE COMPLETE 6-IN-1 VISUAL NURSING TRAINING SYSTEM
              </li>
              {packageIncludes.map((item, itemIndex) => <React.Fragment key={item.label} data-id="element-231" data-mp="3hqi8qc0cbuh" data-mpi={itemIndex}>
                  {itemIndex === firstBonusIndex && <li className="pt-2 text-xs font-bold tracking-widest text-[#025B57]" data-id="element-232" data-mp="3kz09xf4z9tgt">
                      PLUS 5 EXCLUSIVE BONUSES
                    </li>}
                  {itemIndex === firstExtraIndex && <li className="pt-2 border-t border-slate-200" aria-hidden="true" data-id="element-233" data-mp="3bybuqh3uln2c" />}
                  <li className={`flex items-start gap-2 text-sm ${item.kind === 'extra' ? 'font-bold uppercase tracking-wide text-[#0B2545]' : 'text-slate-700'}`} data-id="element-234" data-mp="3fyvnz9law6j7">
                    {item.kind === 'bonus' ? <Gift size={16} className="text-[#0A7D79] shrink-0 mt-0.5" data-id="element-235" data-mp="31cybvvahsks0" /> : <Check size={16} className="text-[#0A7D79] shrink-0 mt-0.5" data-id="element-236" data-mp="3g9fmgkauxvdi" />}
                    <span data-id="element-237" data-mp="3bbnx9y1lknd0">{item.label}</span>
                  </li>
                </React.Fragment>)}
            </ul>

            <div className="mb-6" data-id="element-238" data-mp="3p1rf8ctg1uwn">
              <div className="flex flex-wrap items-baseline justify-center gap-2" data-id="element-239" data-mp="3l0nylo3knuud">
                <span className="text-2xl md:text-3xl text-[#0B2545] font-semibold" data-id="element-240" data-mp="3l2s9wr3svw4o">YOUR PRICE:</span>
                <span className="text-4xl md:text-5xl font-extrabold tracking-tight text-[#0A7D79]" data-id="element-241" data-mp="2syexjsas328">
                  {PRICE_LABEL}
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-242" data-mp="hvzzopvz4s0t">
              {PRIMARY_CTA}
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-slate-500" data-id="element-243" data-mp="vq0p2t11d2oi">
              <span className="flex items-center gap-1.5" data-id="element-244" data-mp="3v54bc8lr8vty">
                <Lock size={12} className="text-[#0A7D79]" data-id="element-245" data-mp="3v6p9s9b6wyx3" /> Secure Payment
              </span>
              <span className="flex items-center gap-1.5" data-id="element-246" data-mp="32wfsbuwu26x">
                <Zap size={12} className="text-[#0A7D79]" data-id="element-247" data-mp="7yv98dv3iae7" /> Immediate Access
              </span>
              <span className="flex items-center gap-1.5" data-id="element-248" data-mp="d013ig4em5pu">
                <Wallet size={12} className="text-[#0A7D79]" data-id="element-249" data-mp="1jf22yvsn1616" /> One-Time Payment
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}